import { Container, Card } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './StrategicGoals.css';

export interface StrategicGoalsProps {
  goals: AboutContentDto['strategicGoals'];
}

/**
 * Renders the `strategicGoals` field under the heading «حوزه‌های فعالیت»
 * (business activity areas) rather than a literal "strategic goals" label —
 * the real company content (see content/about.content.ts) is a list of the
 * company's operational domains (exploration, extraction, processing,
 * project development), which fits this exact title+description shape
 * better than inventing a separate, redundant "goals" list alongside it.
 */
export function StrategicGoals({ goals }: StrategicGoalsProps) {
  if (goals.length === 0) {
    return null;
  }
  return (
    <section className="dma-strategic-goals" aria-labelledby="dma-strategic-goals-heading">
      <Container>
        <h2 id="dma-strategic-goals-heading">حوزه‌های فعالیت</h2>
        <div className="dma-strategic-goals__grid">
          {goals.map((goal) => (
            <Card key={goal.title} className="dma-strategic-goals__item">
              <h3 className="dma-strategic-goals__title">{goal.title}</h3>
              <p className="dma-strategic-goals__description">{goal.description}</p>
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
}
